// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7538 ? "recorder" : chunkId) + "." + {"2009":"550aaa56cfb9d8a9","6492":"9d678b16386df412","7538":"183cc28ae6aa5a4b"}[chunkId] + ".js";
};